import React, { useContext } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { BufferService } from '../utils/buffer.service'
import LoadingContext from '../utils/loading.context'
import './login.css'

export default function UserConfirmEmail() {
    const ctx = useContext(LoadingContext)
    const navigate = useNavigate()
    const location = useLocation()
    const ConfirmEmailBuffer = new BufferService('identity/confirmemail')

    const handleSubmit = (e) => {
        const urlParam = decodeURIComponent(location.search)
        ctx.setIsLoad(true)
        e.preventDefault()
        
        ConfirmEmailBuffer.postQuery(urlParam).then(post => {
            if (post.name === 'AxiosError') {
                ctx.setIsLoad(false)
                ctx.toastMessages('error', '', "Algo correu mal, tente novamente!")
                return
            }
            ctx.setIsLoad(false)
            ctx.toastMessages('success', "Email confirmado com sucesso!")
            setTimeout(function () {
                navigate('/')
            }, 2000)
        })
    }

    return (
        <form onSubmit={handleSubmit}>
            <div style={{ marginTop: '25px' }} className='spanNoteCancelV2'>
                <span style={{ fontSize: '20px', textTransform: 'inherit' }}>A confirmação está a um click!</span>
            </div>
            <div className='divCancelButtonV2'>
                <button type="submit" className='buttonCancelV2'>
                    Confirmar email
                </button>
            </div>
            <div className='spanNoteCancelV2'>
                <span style={{ fontSize: '14px', textTransform: 'inherit' }}>*Nota: Será informado via email desta confirmação!</span>
            </div>
        </form>
    )
}